import { EPJ } from "../../core/theme";
// ═══════════════════════════════════════════════════════════════
//  Catalogue des tâches d'avancement — 3 couches
//  1. FACTORY (dans le code, ci-dessous, jamais perdu)
//  2. MODÈLE GLOBAL (Firestore tasksConfig/default) — modifiable par l'admin
//  3. OVERRIDE PAR CHANTIER (chantier.avancementTasksOverride)
//
//  Tâches de certaines catégories sont GÉNÉRÉES selon la typologie bâtiment :
//   - "beton" / "placo" : 100% généré (une tâche par niveau).
//   - "logements" / "courant-faible" : MIXTE = tâches PAR ÉTAGE (appareillage /
//     RJ45, même mécanique que placo) PRÉFIXÉES à une liste FIXE d'usine.
//  Ces 4 catégories sont read-only (comme beton/placo) : non éditables au modèle
//  global ni par chantier. Les autres catégories sont 100% éditables.
// ═══════════════════════════════════════════════════════════════

// ─── Listes FIXES des catégories mixtes (préfixées par les tâches par étage) ──
// Hors FACTORY_CATEGORIES.tasks car la catégorie est "generated" (tasks: []) :
// le builder concatène [tâches par étage] + [liste fixe ci-dessous].
const FIXED_LOG_TASKS = [
  { id: "log-1", label: "Pose DCL" },
  { id: "log-2", label: "Pose DB + Platine" },
  { id: "log-3", label: "ECL balcon" },
  { id: "log-4", label: "Prise balcon" },
  { id: "log-5", label: "Tableau" },
  { id: "log-6", label: "Porte + trappe de tableau" },
  { id: "log-10", label: "Pose des sèche-serviette" },
  { id: "log-7", label: "Plaque de finition" },
  { id: "log-8", label: "Essai + Ampoule" },
  { id: "log-9", label: "Contrôle qualité" },
];
const FIXED_CF_TASKS = [
  { id: "cf-1", label: "Étier interphone" },
  { id: "cf-2", label: "Câblage tableau de communication" },
  { id: "cf-3", label: "Colonne interphone" },
  { id: "cf-4", label: "Colonne TV" },
  { id: "cf-5", label: "Colonne Fibre" },
  { id: "cf-6", label: "Tirage des fibres lgt + DTIO" },
  { id: "cf-7", label: "Pose Mâts + antennes" },
  { id: "cf-8", label: "Combiné Interphone" },
  { id: "cf-10", label: "Platine Interphone" },
  { id: "cf-9", label: "Programmation + essai interphone" },
];
// Liste FIXE de la catégorie "placo" (générée par niveau) — pattern FIXED_LOG_TASKS.
const FIXED_PLACO_TASKS = [
  { id: "pla-1", label: "Pose BAC D'encastrement" },
];

// ─── 1. FACTORY (modèle d'usine, jamais perdu) ──────────────────
// Les catégories générées ("beton", "placo", "logements", "courant-faible")
// portent tasks: [] : leurs tâches dépendent de la config bâtiment (cf. builders).

export const FACTORY_CATEGORIES = [
  {
    id: "etude", num: 1, label: "ÉTUDE / TMA", color: EPJ.catEtude,
    generated: false,
    tasks: [
      { id: "etude-1", label: "Préparation du dossier chantier" },
      { id: "etude-2", label: "Demande de renseignement autre lot" },
      { id: "etude-3", label: "Réservation" },
      { id: "etude-4", label: "TMA" },
    ],
  },
  {
    id: "beton", num: 2, label: "INCORPORATION BÉTON", color: EPJ.gray500,
    generated: "beton", // généré selon la config
    tasks: [], // généré
  },
  {
    id: "divers", num: 3, label: "AVANCEMENT DIVERS", color: EPJ.orange,
    generated: false,
    // Ordre = ordre d'AFFICHAGE. Les ids sont STABLES (avancement keyé dessus).
    tasks: [
      { id: "divers-1",  label: "Installation de chantier" },
      { id: "divers-2",  label: "Équipement sous-sol lustrerie" },
      { id: "divers-14", label: "Équipement sous-sol bloc secours" },
      { id: "divers-3",  label: "Equipement box ECL + PC" },
      { id: "divers-4",  label: "Chemin de câble" },
      { id: "divers-5",  label: "Préparation des gaines techniques" },
      { id: "divers-6",  label: "Préparation avant doublage" },
      { id: "divers-7",  label: "Amorce colonne" },
      { id: "divers-12", label: "Amorce colonne IRVE" },
      { id: "divers-8",  label: "Cheminement colonne IRVE" },
      { id: "divers-9",  label: "Tronçon colonne IRVE" },
      { id: "divers-10", label: "Colonne IRVE (SPCM)" },
      { id: "divers-11", label: "Equipement box IRVE" },
      { id: "divers-13", label: "Pose coffret de Façade" },
    ],
  },
  {
    id: "placo", num: 4, label: "AVANCEMENT PLACO", color: EPJ.red,
    generated: "placo",
    tasks: [],
  },
  {
    id: "logements", num: 5, label: "ÉQUIPEMENT DES LOGEMENTS", color: EPJ.blue,
    generated: "logements", // par étage (appareillage) + liste fixe FIXED_LOG_TASKS
    tasks: [],
  },
  {
    id: "communs", num: 6, label: "ÉQUIPEMENT DES COMMUNS", color: EPJ.blue,
    generated: false,
    tasks: [
      { id: "com-1",  label: "Colonne Montante" },
      { id: "com-2",  label: "Colonne de terre" },
      { id: "com-3",  label: "Colonne service généraux" },
      { id: "com-4",  label: "Appareillage" },
      { id: "com-5",  label: "Pose DB + Platine" },
      { id: "com-6",  label: "Armoire des services généraux" },
      { id: "com-8",  label: "Lustrerie coursive" },
      { id: "com-9",  label: "Lustrerie escalier" },
      { id: "com-10", label: "Lustrerie extérieur" },
    ],
  },
  {
    id: "courant-faible", num: 7, label: "COURANT FAIBLE", color: EPJ.catCourantFaible,
    generated: "courant-faible", // par étage (RJ45) + liste fixe FIXED_CF_TASKS
    tasks: [],
  },
  {
    id: "controle", num: 8, label: "CONTRÔLE ET MISE EN SERVICE", color: EPJ.green,
    generated: false,
    tasks: [
      { id: "ctrl-1", label: "Pré Réception colonne ENEDIS" },
      { id: "ctrl-2", label: "Réception colonne ENEDIS" },
      { id: "ctrl-3", label: "Réception colonne ORANGE" },
      { id: "ctrl-4", label: "Consuel" },
      { id: "ctrl-5", label: "Mise en service colonne" },
      { id: "ctrl-6", label: "Mise en service groupé" },
    ],
  },
];

// ─── Catégories éditables (celles qui ne sont pas générées) ────
export const EDITABLE_CATEGORY_IDS = FACTORY_CATEGORIES
  .filter(c => !c.generated)
  .map(c => c.id);

// ─── Génération BÉTON selon la typologie ───────────────────────
function buildBetonTasks(cfg) {
  const tasks = [{ id: "beton-radier", label: "Radier" }];
  const ss = Number(cfg?.nbSousSols || 0);
  const et = Number(cfg?.nbEtages || 0);
  const combles = !!cfg?.combles;

  for (let i = ss; i >= 1; i--) {
    const suffix = ss > 1 ? ` ${i}` : "";
    tasks.push({ id: `beton-mur-ss${i}`,   label: `Mur Sous-sol${suffix}` });
    tasks.push({ id: `beton-dalle-ss${i}`, label: `Dalle Sous-sol${suffix}` });
  }
  tasks.push({ id: "beton-mur-rdc",   label: "Mur RDC" });
  tasks.push({ id: "beton-dalle-rdc", label: "Dalle RDC" });
  for (let i = 1; i <= et; i++) {
    tasks.push({ id: `beton-mur-r${i}`,   label: `Mur R+${i}` });
    tasks.push({ id: `beton-dalle-r${i}`, label: `Dalle R+${i}` });
  }
  if (combles) tasks.push({ id: "beton-combles", label: `Combles R+${et + 1}` });
  return tasks;
}

// ─── Génération PLACO selon la typologie (SANS sous-sol) ────────
// Placo ne couvre plus le sous-sol (ni en bâtiment, ni en sous-sol commun) :
// uniquement RDC + étages, libellés "Placo RDC" / "Placo R+{i}".
function buildPlacoTasks(cfg) {
  const tasks = [{ id: "placo-rdc", label: "Placo RDC" }];
  const et = Number(cfg?.nbEtages || 0);
  for (let i = 1; i <= et; i++) {
    tasks.push({ id: `placo-r${i}`, label: `Placo R+${i}` });
  }
  return tasks;
}

// ─── Génération PAR ÉTAGE générique (même mécanique que placo) ──
// RDC + r1..r{nbEtages} ; ni sous-sol, ni combles. Utilisée par les catégories
// mixtes (appareillage logements, RJ45 courant faible).
function buildFloorTasks(cfg, idPrefix, labelPrefix) {
  const tasks = [{ id: `${idPrefix}-rdc`, label: `${labelPrefix} RDC` }];
  const et = Number(cfg?.nbEtages || 0);
  for (let i = 1; i <= et; i++) {
    tasks.push({ id: `${idPrefix}-r${i}`, label: `${labelPrefix} R+${i}` });
  }
  return tasks;
}

// ─── Dispatch des catégories GÉNÉRÉES (clé = cat.generated) ─────
// Les catégories mixtes concatènent [tâches par étage] + [liste fixe d'usine].
const GENERATED_BUILDERS = {
  beton: buildBetonTasks,
  placo: (cfg) => [...buildPlacoTasks(cfg), ...FIXED_PLACO_TASKS],
  logements: (cfg) => [...buildFloorTasks(cfg, "appareillage", "Appareillage"), ...FIXED_LOG_TASKS],
  "courant-faible": (cfg) => [...buildFloorTasks(cfg, "cf-rj45", "Appareillage RJ45"), ...FIXED_CF_TASKS],
};

// ─── Génération des tâches d'un SOUS-SOL COMMUN ────────────────
// cfg = { nbNiveaux }
// Un sous-sol commun ne porte QUE les niveaux de sous-sol :
// pas de radier (il reste sur le bâtiment), pas de RDC / étages.
function buildSousSolBetonTasks(cfg) {
  const tasks = [];
  const nb = Number(cfg?.nbNiveaux || 0);
  for (let i = nb; i >= 1; i--) {
    const suffix = nb > 1 ? ` ${i}` : "";
    tasks.push({ id: `beton-mur-ss${i}`,   label: `Mur Sous-sol${suffix}` });
    tasks.push({ id: `beton-dalle-ss${i}`, label: `Dalle Sous-sol${suffix}` });
  }
  return tasks;
}
// NB : plus de génération PLACO en sous-sol commun (placo ne couvre plus le sous-sol).

// Équipement d'un sous-sol commun (catégorie éditable par chantier)
export const SOUSSOL_EQUIP_TASKS = [
  { id: "ssequip-1", label: "Chemin de câble" },
  { id: "ssequip-2", label: "Éclairage / Lustrerie" },
  { id: "ssequip-3", label: "Bloc secours (BAES)" },
  { id: "ssequip-4", label: "Équipement box / garage" },
  { id: "ssequip-5", label: "Détection / commande" },
  { id: "ssequip-6", label: "Essai + Contrôle qualité" },
  { id: "ssequip-7",  label: "Amorce colonne IRVE" },
  { id: "ssequip-8",  label: "Cheminement colonne IRVE" },
  { id: "ssequip-9",  label: "Tronçon colonne IRVE" },
  { id: "ssequip-10", label: "Colonne IRVE (SPCM)" },
  { id: "ssequip-11", label: "Equipement box IRVE" },
];

// Catégories d'un sous-sol commun : béton (généré) + équipement (éditable).
// Plus de placo en sous-sol commun.
function buildSousSolCategories(cfg) {
  return [
    { id: "beton",   num: 2, label: "INCORPORATION BÉTON",  color: EPJ.gray500, generated: "beton", tasks: buildSousSolBetonTasks(cfg) },
    { id: "ssequip", num: 6, label: "ÉQUIPEMENT SOUS-SOL",  color: EPJ.blue, generated: false,   tasks: SOUSSOL_EQUIP_TASKS },
  ];
}

// ─── Fusion FACTORY + MODÈLE GLOBAL ─────────────────────────────
// Le modèle global peut :
//   - Modifier le label d'une tâche existante
//   - Ajouter des tâches (avec id custom)
//   - Supprimer des tâches (en les absentant)
// Le modèle global stocke chaque catégorie comme : { tasks: [...] }
function mergeWithGlobalModel(factory, globalModel) {
  if (!globalModel || !globalModel.categories) return factory;
  return factory.map(cat => {
    const override = globalModel.categories[cat.id];
    if (!override || !Array.isArray(override.tasks)) return cat;
    // Les catégories générées ne sont pas modifiables au niveau modèle global
    if (cat.generated) return cat;
    return { ...cat, tasks: override.tasks };
  });
}

// ─── Fusion avec override CHANTIER ──────────────────────────────
function mergeWithChantierOverride(categories, chantierOverride, buildingId) {
  if (!chantierOverride) return categories;
  const byBuilding = chantierOverride[buildingId] || chantierOverride._all || null;
  if (!byBuilding || !byBuilding.categories) return categories;
  return categories.map(cat => {
    const override = byBuilding.categories[cat.id];
    if (!override || !Array.isArray(override.tasks)) return cat;
    return { ...cat, tasks: override.tasks };
  });
}

// ─── Masquage conditionnel DIVERS (sous-sol commun) ────────────
// Quand le chantier a ≥1 sous-sol commun, ces tâches divers sont couvertes par
// l'unité "sous-sol commun" : elles ne sont PAS affichées (ni comptées dans le %)
// dans les catégories PAR BÂTIMENT. AFFICHAGE SEUL — aucune écriture Firestore ;
// les saisies déjà faites restent en base (ids conservés).
const DIVERS_HIDDEN_WITH_SOUSSOL = new Set([
  "divers-2", "divers-14", "divers-3", "divers-4",
  "divers-8", "divers-9", "divers-10", "divers-11", "divers-12",
]);

// ─── Retourne toutes les catégories pour un chantier/bâtiment ──
// cfg = typologie du bâtiment (sous-sols, étages, combles)
// tasksConfig = modèle global depuis Firestore
// chantierOverride = chantier.avancementTasksOverride
// buildingId = "A" / "B" / "C"... (pour cibler l'override)
// hasSousSolCommun = le chantier a ≥1 sous-sol commun → masque certaines tâches
//   divers côté bâtiment (AFFICHAGE SEUL, cf. DIVERS_HIDDEN_WITH_SOUSSOL)
// excludeEtude = l'étude/TMA est une UNITÉ CHANTIER (cf. getCategoriesForEtude) :
//   les vues d'avancement PAR BÂTIMENT passent true pour ne pas l'afficher/compter
//   côté bâtiment. Défaut false → les appelants qui énumèrent toute la taxonomie
//   (ex. picker du planning) conservent la catégorie "etude" inchangée.
export function getCategoriesForConfig(cfg, tasksConfig, chantierOverride, buildingId, hasSousSolCommun = false, excludeEtude = false) {
  // Bâtiment rattaché à un sous-sol commun : ses tâches de sous-sol privées sont
  // MASQUÉES (nbSousSols forcé à 0 pour la génération uniquement). nbSousSols n'est
  // jamais muté en base, donc l'opération est réversible au détachement.
  const genCfg = getSousSolIdFromConfig(cfg) != null ? { ...cfg, nbSousSols: 0 } : cfg;

  // 1. FACTORY (génère les tâches dynamiques selon cat.generated)
  //    L'étude/TMA est exclue côté bâtiment (unité chantier) quand demandé.
  const factory = excludeEtude
    ? FACTORY_CATEGORIES.filter(cat => cat.id !== "etude")
    : FACTORY_CATEGORIES;
  let cats = factory.map(cat => {
    const build = cat.generated ? GENERATED_BUILDERS[cat.generated] : null;
    return build ? { ...cat, tasks: build(genCfg) } : cat;
  });

  // 2. Applique le modèle global
  cats = mergeWithGlobalModel(cats, tasksConfig);

  // 3. Applique l'override chantier
  cats = mergeWithChantierOverride(cats, chantierOverride, buildingId);

  // 4. Masquage conditionnel (AFFICHAGE SEUL) : sous-sol commun présent →
  //    on retire les tâches divers couvertes par le sous-sol.
  if (hasSousSolCommun) {
    cats = cats.map(cat =>
      cat.id === "divers"
        ? { ...cat, tasks: cat.tasks.filter(t => !DIVERS_HIDDEN_WITH_SOUSSOL.has(t.id)) }
        : cat
    );
  }

  return cats;
}

// ─── Catégories d'un SOUS-SOL COMMUN (unité de suivi autonome) ──
// cfg = { nbNiveaux } ; ssId = clé de l'unité (override / progress keyés dessus)
export function getCategoriesForSousSol(cfg, tasksConfig, chantierOverride, ssId) {
  let cats = buildSousSolCategories(cfg);
  cats = mergeWithGlobalModel(cats, tasksConfig);
  cats = mergeWithChantierOverride(cats, chantierOverride, ssId);
  return cats;
}

// ─── Catégorie ÉTUDE / TMA — unité de suivi CHANTIER (une seule par chantier) ──
// L'étude et la TMA se font pour tout le chantier, pas par bâtiment : l'étude
// devient une "unité" autonome (comme un sous-sol commun), keyée sur "etude"
// dans avancementProgress / avancementTasksOverride. Elle porte UNIQUEMENT la
// catégorie factory "etude" (etude-1..4), + fusion modèle global + override
// chantier — même mécanique que le reste. Les bâtiments l'excluent
// (getCategoriesForConfig(..., excludeEtude=true)).
export function getCategoriesForEtude(tasksConfig, chantierOverride) {
  let cats = FACTORY_CATEGORIES.filter(cat => cat.id === "etude");
  cats = mergeWithGlobalModel(cats, tasksConfig);
  cats = mergeWithChantierOverride(cats, chantierOverride, "etude");
  return cats;
}

// ─── Pour l'édition du modèle global ─────────────────────────────
// Retourne les catégories éditables avec leurs tâches (après modèle global)
export function getEditableCategoriesForModel(tasksConfig) {
  const cats = FACTORY_CATEGORIES.filter(c => !c.generated);
  return mergeWithGlobalModel(cats, tasksConfig);
}

// ─── Pour l'édition par chantier ─────────────────────────────────
// Retourne TOUTES les catégories (éditables + générées en read-only)
export function getCategoriesForChantierEdit(cfg, tasksConfig, chantierOverride, buildingId) {
  return getCategoriesForConfig(cfg, tasksConfig, chantierOverride, buildingId);
}

// ─── Calculs ────────────────────────────────────────────────────
export function categoryProgress(category, progressData) {
  if (!category.tasks || category.tasks.length === 0) return 0;
  let sum = 0, count = 0;
  for (const t of category.tasks) {
    sum += Number(progressData?.[t.id] || 0);
    count++;
  }
  return count > 0 ? Math.round(sum / count) : 0;
}

function overallFromCats(cats, progressData) {
  let sum = 0, count = 0;
  for (const cat of cats) {
    for (const t of cat.tasks) {
      sum += Number(progressData?.[t.id] || 0);
      count++;
    }
  }
  return count > 0 ? Math.round(sum / count) : 0;
}

export function overallProgress(cfg, progressData, tasksConfig, chantierOverride, buildingId, hasSousSolCommun = false, excludeEtude = false) {
  return overallFromCats(
    getCategoriesForConfig(cfg, tasksConfig, chantierOverride, buildingId, hasSousSolCommun, excludeEtude),
    progressData,
  );
}

// % de l'unité ÉTUDE / TMA (une par chantier), keyée "etude" dans avancementProgress.
export function overallProgressEtude(progressData, tasksConfig, chantierOverride) {
  return overallFromCats(
    getCategoriesForEtude(tasksConfig, chantierOverride),
    progressData,
  );
}

export function overallProgressSousSol(cfg, progressData, tasksConfig, chantierOverride, ssId) {
  return overallFromCats(
    getCategoriesForSousSol(cfg, tasksConfig, chantierOverride, ssId),
    progressData,
  );
}

export const DEFAULT_BUILDING_CONFIG = {
  nbSousSols: 1, nbEtages: 3, combles: false,
};

export const DEFAULT_SOUSSOL_CONFIG = { nbNiveaux: 1 };

// ─── Lettre / id technique de bâtiment ──────────────────────────
// On découple l'id technique (clé STABLE de stockage de l'avancement,
// jamais modifiée) de la lettre affichée (éditable). Fallback sur l'id
// pour les bâtiments existants qui n'ont pas encore de champ `lettre`.
export function getBuildingLetter(building) {
  return building?.lettre || building?.id || "?";
}
// id technique stable pour un nouveau bâtiment (la lettre, elle, reste libre/éditable)
export function generateBuildingId() {
  return `bat-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

// ─── Helpers sous-sol commun ───────────────────────────────────
// sousSolId reste un SCALAIRE en V1. Passer systématiquement par ce helper
// permettra de le faire évoluer vers un tableau plus tard sans toucher aux appelants.
export function getSousSolIdFromConfig(config) {
  const v = config?.sousSolId;
  return v == null ? null : v;
}
export function getBuildingSousSolId(building) {
  return getSousSolIdFromConfig(building?.config);
}
export function getChantierSousSols(chantier) {
  return Array.isArray(chantier?.sousSolsCommuns) ? chantier.sousSolsCommuns : [];
}
// Liste des bâtiments d'un chantier, avec le bâtiment "A" par défaut si aucun
export function resolveBuildings(chantier) {
  return chantier?.buildings && chantier.buildings.length > 0
    ? chantier.buildings
    : [{ id: "A", lettre: "A", label: "", config: DEFAULT_BUILDING_CONFIG }];
}
export function generateSousSolId() {
  return `ss-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

// ─── Génère un ID unique pour une nouvelle tâche ────────────────
export function generateTaskId(categoryId) {
  return `${categoryId}-custom-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

// ─── Génère un ID unique pour une nouvelle session d'heures ─────
export function generateSessionId() {
  return `sess-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

// ─── Total d'heures pour une liste de sessions ──────────────────
export function totalHoursFromSessions(sessions) {
  if (!Array.isArray(sessions)) return 0;
  return sessions.reduce((sum, s) => sum + (Number(s?.hours) || 0), 0);
}

// ─── Total d'heures sur un bâtiment complet ─────────────────────
export function totalHoursForBuilding(sessionsMap, legacyHoursMap) {
  // sessionsMap = { taskId: [{hours, ...}] }
  // legacyHoursMap = { taskId: hours } (rétrocompat v6)
  let total = 0;
  const seenTasks = new Set();
  if (sessionsMap) {
    for (const taskId in sessionsMap) {
      total += totalHoursFromSessions(sessionsMap[taskId]);
      seenTasks.add(taskId);
    }
  }
  // Pour les tâches qui n'ont PAS de sessions mais un legacyHours, on l'ajoute
  if (legacyHoursMap) {
    for (const taskId in legacyHoursMap) {
      if (!seenTasks.has(taskId)) {
        total += Number(legacyHoursMap[taskId]) || 0;
      }
    }
  }
  return total;
}

// ─── Total d'heures pour une tâche (avec fallback legacy) ───────
export function totalHoursForTask(sessions, legacyHours) {
  const sessionsTotal = totalHoursFromSessions(sessions);
  if (sessionsTotal > 0 || (Array.isArray(sessions) && sessions.length > 0)) {
    return sessionsTotal;
  }
  return Number(legacyHours) || 0;
}
